import { humanize } from "./utils";

export const formatErrorResponse = (res: any) => {
  const errorSource =
    res?.cause?.response?.data ||
    res?.response?.data ||
    res?.data ||
    res?.response ||
    res;
  return (
    errorSource?.msg ||
    errorSource?.detail?.msg ||
    errorSource?.details?.msg ||
    errorSource?.errors
      ?.map((x: any) => humanize(JSON.stringify(x)))
      ?.join(", ") ||
    (errorSource?.details || errorSource?.detail)?.errors
      ?.map((x: any) => humanize(JSON.stringify(x)))
      ?.join(", ") ||
    humanize(JSON.stringify(errorSource?.details || errorSource?.detail)) ||
    humanize(JSON.stringify(errorSource))
  );
};

const MAC_ADDRESS_PATTERN = /^([0-9A-F]{2}:){5}[0-9A-F]{2}$/;

export const validateMacAddress = (value: string) => {
  return MAC_ADDRESS_PATTERN.test(value);
};
